import { BaseModel } from '../base.model';
import {required} from '../json-map.util';

class ProblemRequest {}

namespace ProblemRequest {


  export class Create extends BaseModel {
    @required()
    title: string = undefined;
    @required()
    content: string = undefined;
    passageId: number = undefined;
    @required()
    topicId: number = undefined;
    @required()
    difficulty: number = undefined;
    displayName: string = undefined;
    explanation: string = undefined;

    // This one is optional in case you want to assign an exercise when creating a problem
    exerciseId: number = undefined;
  }

  export class Update extends Create {
    exerciseIds: number[] = undefined;
  }

}

export { ProblemRequest };

